function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { createContext, useReducer } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CardField = /*#__PURE__*/function (CardField) {
  CardField["Cvc"] = "cardCvc";
  CardField["Expiration"] = "cardExpiry";
  CardField["Number"] = "cardNumber";
  return CardField;
}({});
export var CardFieldActionType = /*#__PURE__*/function (CardFieldActionType) {
  CardFieldActionType["Empty"] = "empty";
  CardFieldActionType["Error"] = "error";
  CardFieldActionType["Submit"] = "submit";
  CardFieldActionType["Valid"] = "valid";
  return CardFieldActionType;
}({});
var REQUIRED_VALIDATION_MESSAGES = {
  [CardField.Cvc]: "'s security code",
  [CardField.Expiration]: "'s expiration date",
  [CardField.Number]: ' number'
};
function getRequiredValidationMessage(fieldType) {
  return "Your card" + REQUIRED_VALIDATION_MESSAGES[fieldType] + " is incomplete.";
}

/**
 * Represents the available actions for Card fields
 */

var initialCardFieldState = {
  [CardField.Cvc]: null,
  [CardField.Expiration]: null,
  [CardField.Number]: null
};
var initialCardState = {
  errors: initialCardFieldState,
  isValid: () => false,
  onCardEmpty: () => {},
  onCardError: () => {},
  onCardValid: () => {},
  onFormSubmit: () => {}
};
export var CardErrorContext = /*#__PURE__*/createContext(initialCardState);
export var cardEmptyAction = name => ({
  type: CardFieldActionType.Empty,
  name
});
export var cardErrorAction = (name, message) => ({
  type: CardFieldActionType.Error,
  name,
  message
});
export var cardValidAction = name => ({
  type: CardFieldActionType.Valid,
  name
});
export var cardSubmitAction = () => ({
  type: CardFieldActionType.Submit
});
export function cardStateReducer(state, action) {
  switch (action.type) {
    case CardFieldActionType.Empty:
      return Object.assign({}, state, {
        [action.name]: getRequiredValidationMessage(action.name)
      });
    case CardFieldActionType.Error:
      return Object.assign({}, state, {
        [action.name]: action.message
      });
    case CardFieldActionType.Valid:
      return Object.assign({}, state, {
        [action.name]: true
      });
    case CardFieldActionType.Submit:
      return Object.assign({}, state, {
        [CardField.Cvc]: state[CardField.Cvc] === null ? getRequiredValidationMessage(CardField.Cvc) : state[CardField.Cvc],
        [CardField.Expiration]: state[CardField.Expiration] === null ? getRequiredValidationMessage(CardField.Expiration) : state[CardField.Expiration],
        [CardField.Number]: state[CardField.Number] === null ? getRequiredValidationMessage(CardField.Number) : state[CardField.Number]
      });
    default:
      return state;
  }
}

/**
 * Stripe Card Error Context Provider
 *
 * Maintains validation state of Stripe Elements to manage submission
 */
export var CardErrorContextProvider = _ref => {
  var {
    children
  } = _ref;
  var [fieldErrors, dispatch] = useReducer(cardStateReducer, initialCardFieldState);
  var contextValues = {
    errors: fieldErrors,
    isValid: () => fieldErrors[CardField.Number] === true && fieldErrors[CardField.Expiration] === true && fieldErrors[CardField.Cvc] === true,
    onCardEmpty: elementType => {
      dispatch(cardEmptyAction(elementType));
    },
    onCardError: (elementType, message) => {
      dispatch(cardErrorAction(elementType, message));
    },
    onCardValid: elementType => {
      dispatch(cardValidAction(elementType));
    },
    onFormSubmit: () => {
      dispatch(cardSubmitAction());
    }
  };
  return ___EmotionJSX(CardErrorContext.Provider, {
    value: _extends({}, contextValues)
  }, children);
};